import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TUI_IS_IOS, TUI_IS_MOBILE } from '@taiga-ui/cdk';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { TabsModule } from 'src/app/components/tabs/tabs.module';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  // template: './header.component.html',
  styles: [
    `
      .bg-color {
        //background: linear-gradient(180deg, #cf0e10 0%, #97000d 100%);
        background:#F40C34;
      }
    `,
  ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() onOpenMenu = new EventEmitter<boolean>();

  portals: string[] = [];
  selectedPortal: string = '';
  hasMultiplePortals = false;
  currentPortal: string = ''; // Nueva variable para controlar el submenú

  goBackRoutes = ['new-contact', 'edit-contact', 'profile/edit'];
  showGoBackButton = false;
  private subscriptions = new Subscription();
  send_money: string = `send_money_button`;
  constructor(
    private authService: AuthService,
    public router: Router,
    private location: Location,
    @Inject(TUI_IS_MOBILE) readonly isMobile: boolean,
    @Inject(TUI_IS_IOS) readonly isIos: boolean
  ) {}

  ngOnInit() {
    // Recuperar portal guardado


    this.subscriptions.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.showGoBackButton = this.isCurrentRouteInGoBackRoutes();
        }
      })
    );

    // Suscribirse a isLoggedIn$ para cargar portales solo si está logueado
    this.subscriptions.add(
      this.authService.isLoggedIn$.subscribe((loggedIn) => {
        if (loggedIn) {
          this.loadPortals();   // Solo carga portales si está logueado
        } else {
          this.portals = [];    // Limpia portales si no está logueado
          this.hasMultiplePortals = false;
        }
      })
    );
    const storedPortal = localStorage.getItem('selectedPortal');
    if (storedPortal) {
      this.selectedPortal = storedPortal;
    }
  }

  loadPortals() {
    const portalsData = localStorage.getItem('userPortal');
    if (portalsData) {
      this.portals = portalsData.split(',').map(p => p.trim().toLowerCase());
      // todo: mostrar también a superadmins. eiminar datos de caché
      this.hasMultiplePortals = this.portals.length > 1;

      // Verificar si el portal seleccionado está en la lista de portales
      if (!this.portals.includes(this.selectedPortal)) {
        if (this.router.url.includes('btb') && this.portals.includes('btb')) {
          this.selectedPortal = 'btb';
        } else if (this.router.url.includes('backoffice') && this.portals.includes('backoffice')) {
          this.selectedPortal = 'backoffice';
        } else {
          this.selectedPortal = 'cliente';
        }

        // Si no está, seleccionar el primer portal disponible
        // this.selectedPortal = this.portals[0];
        localStorage.setItem('selectedPortal', this.selectedPortal); // Guardar el nuevo portal seleccionado
      }
    }
  }

selectPortal(portal: string) {
  this.selectedPortal = portal;
  localStorage.setItem('selectedPortal', portal);  // Guardar portal seleccionado

  switch (portal) {
    case 'cliente':
      this.router.navigate(['/home']);
      break;
    case 'btb':
      this.router.navigate(['/btb']);
      break;
    case 'backoffice':
      this.router.navigate(['/backoffice/dashboard']);
      break;
    default:
      console.error('Portal no válido');
  }
}


get showTabsOrSidenav(): string {
  if (!this.isMobile || this.isIos) {
    if (this.selectedPortal === 'backoffice') return 'backoffice';
    if (this.selectedPortal === 'btb') return 'btb';
    return 'tabs';
  }
  return '';
}


  isCurrentRouteInGoBackRoutes(): boolean {
    const currentUrl = this.router.url;
    return this.goBackRoutes.some((route) => currentUrl.includes(route));
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  signOut() {
    this.authService.logout();
  }
}
